var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('img',{class:[
    {
      'current-flag': _vm.flag,
      'small-icon': _vm.smallIcon,
      'medium-icon': _vm.mediumIcon,
    },
    _vm.className ],attrs:{"title":_vm.$t(_vm.title),"src":_vm.src}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }